import { contactData } from "@/mocks/homeData";

export default function ContactSection() {
  return (
    <section id="contact" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            {contactData.title}
          </h2>
          <p className="mt-2 text-sm font-medium text-primary-500 whitespace-nowrap">
            {contactData.subtitle}
          </p>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-[600px] mx-auto">
            {contactData.desc}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          <div className="bg-background-100 rounded-lg border border-background-200/60 p-5 text-center">
            <div className="w-11 h-11 mx-auto flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
              <i className="ri-mail-line text-xl" />
            </div>
            <h3 className="mt-3 text-sm font-semibold text-foreground-900 whitespace-nowrap">
              电子邮箱
            </h3>
            <p className="mt-1 text-xs text-foreground-600 break-all">
              {contactData.email}
            </p>
          </div>

          <div className="bg-background-100 rounded-lg border border-background-200/60 p-5 text-center">
            <div className="w-11 h-11 mx-auto flex items-center justify-center rounded-full bg-secondary-50 text-secondary-500">
              <i className="ri-qq-line text-xl" />
            </div>
            <h3 className="mt-3 text-sm font-semibold text-foreground-900 whitespace-nowrap">
              QQ 群组
            </h3>
            <p className="mt-1 text-xs text-foreground-600 break-all">
              {contactData.qq}
            </p>
          </div>

          <div className="bg-background-100 rounded-lg border border-background-200/60 p-5 text-center">
            <div className="w-11 h-11 mx-auto flex items-center justify-center rounded-full bg-accent-50 text-accent-500">
              <i className="ri-wechat-line text-xl" />
            </div>
            <h3 className="mt-3 text-sm font-semibold text-foreground-900 whitespace-nowrap">
              微信公众号
            </h3>
            <p className="mt-1 text-xs text-foreground-600 break-all">
              {contactData.wechat}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}